import React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import MonitoringPage from "./pages/monitoring/Index";
import MonitoringDashboardView from "./pages/monitoring/MonitoringDashboardView";
import AdminPage from "./pages/admin/Index";
import DashboardsPage from "./pages/admin/dashboards/DashboardsPage";
import DashboardEditorPage from "./pages/admin/dashboards/DashboardEditorPage";
import DashboardViewerPage from "./pages/admin/dashboards/DashboardViewerPage";

function KeyedMonitoringDashboardView() {
  const { slug } = useParams<{ slug: string }>();
  return <MonitoringDashboardView key={slug} />;
}

function AuthCallbackPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <span className="text-secondary text-sm">Signing in…</span>
    </div>
  );
}

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/postlogin" element={<AuthCallbackPage />} />
    <Route
      path="/home"
      element={
        <PrivateRoute>
          <HomePage />
        </PrivateRoute>
      }
    />
    <Route
      path="/monitoring"
      element={
        <PrivateRoute>
          <MonitoringPage />
        </PrivateRoute>
      }
    >
      <Route path=":slug" element={<KeyedMonitoringDashboardView />} />
    </Route>
    <Route
      path="/admin"
      element={
        <PrivateRoute>
          <AdminRoute>
            <AdminPage />
          </AdminRoute>
        </PrivateRoute>
      }
    >
      <Route index element={<Navigate to="/admin/dashboards" replace />} />
      <Route path="dashboards" element={<DashboardsPage />} />
    </Route>
    <Route
      path="/admin/dashboards/:slug"
      element={
        <PrivateRoute>
          <AdminRoute>
            <DashboardViewerPage />
          </AdminRoute>
        </PrivateRoute>
      }
    />
    <Route
      path="/admin/dashboards/:slug/edit"
      element={
        <PrivateRoute>
          <AdminRoute>
            <DashboardEditorPage />
          </AdminRoute>
        </PrivateRoute>
      }
    />
    <Route path="/dashboards" element={<Navigate to="/admin/dashboards" replace />} />

    <Route path="/" element={<Navigate to="/home" replace />} />
    <Route path="*" element={<Navigate to="/home" replace />} />
  </Routes>
);

export default AppRoutes;
